<template>
	<span class="sr-only">
		<slot name="message">
			{{ message }}
		</slot>
	</span>
</template>

<script>
	export default {
		name: "AriaNewTabMessage",
		props: {
			message: {
				type    : String,
				default : "Opens in a new tab"
			}
		}
	}
</script>
